export default "__VITE_ASSET__DMXTDpf0__"